import type { DatadogFlagsClient } from "./initializeDatadogFlags";

/** Record the A/A assignment; both variants intentionally render the same UI. */
export const evaluateDatadogAaValidation = (client: DatadogFlagsClient): void => {
    client.getBooleanValue({ key: "ecco-aa-validation", defaultValue: false });
};
